import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import adicionarFiltroBagagem from '../../actions/bagagem/adicionarFiltroBagagem';
import removerFiltroBagagem from '../../actions/bagagem/removerFiltroBagagem';
import listarFiltrosBagagem from '../../actions/bagagem/listarFiltrosBagagem';
import {
    FILTRO_DATA_CRIACAO,
    FILTRO_VENDEDOR,
    FILTRO_NOME_PASSAGEIRO,
    FILTRO_STATUS_BAGAGEM,
} from '../../util/filtros';
import FiltroBuscaBagagem from './FiltroBuscaBagagem';

export class FiltroBagagem extends Component {
    componentDidMount() {
        this.props.listarFiltrosBagagem()
    }


    adicionarFiltro(filtro) {
        this.props.adicionarFiltroBagagem(filtro)
    }

    removerFiltro(filtro) {
        this.props.removerFiltroBagagem(filtro)
    }

    render() {
        if (!this.props.plataformas) {
            return <div>Carregando...</div>
        }

        return (
            <React.Fragment>
                <div className="conteudo">
                    <FiltroBuscaBagagem
                        filtro={FILTRO_DATA_CRIACAO}
                        opcoes={[new Date().getFullYear()]}
                        isFiltroData={true}
                    />

                    <FiltroBuscaBagagem
                        filtro={FILTRO_VENDEDOR}
                        isNome={true}
                    />

                    <FiltroBuscaBagagem
                        filtro={FILTRO_NOME_PASSAGEIRO}
                        isNome={true}
                        opcoes={[]}
                    />
                    <FiltroBuscaBagagem
                        filtro={FILTRO_STATUS_BAGAGEM}
                        opcoes={['Ativa', 'Inativa']}
                        isRadio={true}
                      />
                </div>
            </React.Fragment>
        )
    }
}

export const mapStateToProps = state => ({
    plataformas: state.filtrosBagagem.plataformas,
    tipos: state.filtrosBagagem.tipos,
    filtrosAdicionados: state.filtrosAdicionadosBagagem

});

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        adicionarFiltroBagagem,
        removerFiltroBagagem,
        listarFiltrosBagagem
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(FiltroBagagem)
